import { FetchScansQuery } from '../lib/api/scans'
import { BaseReportFilterParameters } from '../lib/interfaces/BaseReportFilterParameters.interface'

const moment = require('moment')

export const applyFilterParams = (filterParams: BaseReportFilterParameters): FetchScansQuery => {
    const fromDate = moment(filterParams.fromDate)
    const fromDateTime = moment('05:00', 'HH:mm')

    fromDate.set({
        hour: fromDateTime.get('hour'),
        minute: fromDateTime.get('minute')
    })

    const queryParams: FetchScansQuery = {
        // fromDate: fromDate.format('YYYY-MM-DDTHH:mm:ss')
        fromDate: fromDate.format()
    }

    const toDate = moment(fromDate).add(1, 'day')
    // queryParams.toDate = toDate.format('YYYY-MM-DDTHH:mm:ss')
    queryParams.toDate = toDate.format()

    if (filterParams.vin) {
        queryParams.vin = filterParams.vin
    }

    if (filterParams.location) {
        queryParams.location = filterParams.location
    }

    if (filterParams.position) {
        queryParams.position = filterParams.position
    }

    return queryParams
}


// WEBPACK FOOTER //
// ./src/utils/scans.ts